import RestResource from '../rest.service';

export default class OrderStatesService extends RestResource {
  getColors() {
    return ['warning', 'primary', 'success', 'danger', 'warning', 'dark'];
  }

  constructor() {
    super('order-states');
  }
}
